import type { SearchModes } from '@/domainLogic/index.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import { areTaxesIncludedInPrice } from '@/app/common/config/configuration/configurationUtilsClient.ts';
import { PRICE_DISPLAY_TYPE } from '@/app/components/search/utils/formattingTypes.ts';
import type { Localization } from '../../../common/Localization';
import { formatPrice, formatPriceSpecific } from '../../../utils/formatting';

export const decorateTaxes = ({
  taxes,
  localization,
  searchMode,
  t,
}: {
  taxes?: number;
  localization: Localization;
  searchMode: SearchModes;
  t: TranslationFunction;
}) => {
  const taxesIncludedPopup = localization?.configValuesApp?.taxesIncludedPopup;
  if (taxesIncludedPopup) {
    return t('vacation.oss.cards.taxes_fees_included.all.title');
  }
  if (!taxes) return null;
  const { country, configValuesApp } = localization;
  const onlyCents = taxes > 0 && taxes < 1;
  const amount = onlyCents
    ? formatPriceSpecific({
        price: taxes.toFixed(2),
        locale: localization.locale,
        currency: localization.currency,
        priceDisplayType: PRICE_DISPLAY_TYPE.DECIMALS,
      })
    : formatPrice({
        price: taxes,
        localization,
      });

  const taxesIncluded = areTaxesIncludedInPrice({ searchMode, configValuesApp, country });

  return taxesIncluded
    ? taxesIncludedPopup
      ? t('vacation.oss.cards.taxes_fees_included.dp', { amount })
      : t('vacation.oss.cards.incl_due_later')
    : t('vacation.oss.cards.taxes_fees', { amount });
};
